import { Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HeaderPortalService {
  readonly template = signal<TemplateRef<unknown> | null>(null);

  register(template: TemplateRef<unknown>): void {
    if (this.template()) {
      throw new Error('Template already defined');
    }
    this.template.set(template);
  }

  unregister(template: TemplateRef<unknown>): void {
    if (this.template() === template) {
      this.template.set(null);
    }
  }
}
